// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-base-table,
.custom-table-1 {
  width: 100%;
  text-align: left;
  margin-bottom: 10px;
  border-collapse: collapse;
}
.react-base-table th,
.custom-table-1 th {
  font-weight: 700;
  padding: 4px 10px;
  height: 30px;
  font-size: 1.2em;
  border: 0;
}
.react-base-table td,
.custom-table-1 td {
  font-size: 0.8125rem;
  height: 36px;
  padding: 0 10px;
}
.react-base-table td > svg,
.custom-table-1 td > svg {
  fill: currentColor;
  cursor: pointer;
}
@media (min-width: 767px) {
  .react-base-table td > svg,
  .custom-table-1 td > svg {
    opacity: 0;
  }
}
.react-base-table tr:hover > td > svg,
.custom-table-1 tr:hover > td > svg {
  opacity: 1;
}
.react-base-table tr:hover > td > svg:hover,
.custom-table-1 tr:hover > td > svg:hover {
  fill: currentColor;
}

.sensors-rows ~ .sensors-rows {
  border-top: 1px solid rgba(0, 0, 0, 0.1254901961);
  margin-top: 4px;
}

.stepper-wrapper .stepper {
  padding: 0;
}

.stepper .step-label.step-label-completed:not(.Mui-error),
.stepper .step-label.step-label-active:not(.Mui-error),
.stepper .step-label:not(.Mui-error) {
  color: #fff;
}
.stepper .MuiStep-root {
  padding: 10px;
  margin-bottom: 6px;
}
.stepper .MuiStepContent-root {
  margin-left: 0;
  border-left-width: 0;
  padding: 0;
  margin-top: 0;
}
.stepper .step-connector {
  display: none;
}

.step-label-root svg {
  display: block;
}

.text-warning {
  color: #ffc107;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Units/Style.scss","webpack://./src/assets/variables.scss"],"names":[],"mappings":"AAEA;;EAEI,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;AADJ;AAGI;;EACI,gBAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;EACA,SAAA;AAAR;AAGI;;EACI,oBAAA;EAEA,YAAA;EACA,eAAA;AADR;AAGQ;;EACI,kBAAA;EACA,eAAA;AAAZ;AAEY;EAJJ;;IAKQ,UAAA;EAEd;AACF;AAIQ;;EACI,UAAA;AADZ;AAGY;;EACI,kBAAA;AAAhB;;AAOI;EACI,iDAAA;EACA,eAAA;AAJR;;AASA;EACI,UAAA;AANJ;;AAcQ;;;EACI,WClCQ;ADyBpB;AAaI;EACI,aAAA;EACA,kBAAA;AAXR;AAeI;EACI,cAAA;EACA,oBAAA;EACA,UAAA;EACA,aAAA;AAbR;AAgBI;EACI,aAAA;AAdR;;AAuBA;EACI,cAAA;AApBJ;;AAuBA;EACI,cCvCU;ADmBd","sourcesContent":["@import \"./../../assets/variables.scss\";\n\n.react-base-table,\n.custom-table-1 {\n    width: 100%;\n    text-align: left;\n    margin-bottom: 10px;\n    border-collapse: collapse;\n\n    th {\n        font-weight: 700;\n        padding: 4px 10px;\n        height: 30px;\n        font-size: 1.2em;\n        border: 0;\n    }\n\n    td {\n        font-size: 0.8125rem;\n        //background: #fafafa;\n        height: 36px;\n        padding: 0 10px;\n\n        >svg {\n            fill: currentColor;\n            cursor: pointer;\n\n            @media (min-width: 767px) {\n                opacity: 0;\n            }\n        }\n    }\n\n    tr {\n\n        &:hover>td>svg {\n            opacity: 1;\n\n            &:hover {\n                fill: currentColor;\n            }\n        }\n    }\n}\n\n.sensors-rows {\n    &~& {\n        border-top: 1px solid #00000020;\n        margin-top: 4px;\n    }\n\n}\n\n.stepper-wrapper .stepper {\n    padding: 0;\n}\n\n.stepper {\n\n    .step-label.step-label-completed,\n    .step-label.step-label-active,\n    .step-label {\n        &:not(.Mui-error) {\n            color: $themeColorInverse;\n        }\n    }\n\n    .MuiStep-root {\n        padding: 10px;\n        margin-bottom: 6px;\n    }\n\n\n    .MuiStepContent-root {\n        margin-left: 0;\n        border-left-width: 0;\n        padding: 0;\n        margin-top: 0;\n    }\n\n    .step-connector {\n        display: none;\n        // margin-left: 10px;\n\n        // .MuiStepConnector-lineVertical {\n        //     border-left-width: 0;\n        // }\n    }\n}\n\n.step-label-root svg {\n    display: block;\n}\n\n.text-warning {\n    color: $warning\n}","@import \"functions\";\n@import \"mixins\";\n$themeColor: #00c179;\n$input-focus-box-shadow: none;\n$input-btn-focus-box-shadow: none;\n$btn-active-box-shadow: none;\n$input-focus-border-color: inherit;\n$btn-active-box-shadow: none;\n$input-bg: #fbfeff;\n$input-border-radius: 100px;\n$input-border-radius-sm: 100px;\n$input-border-radius-lg: 100px;\n$input-border-color: #e2e9ef;\n//$input-padding-x-sm: 10px;\n@import \"bs_variables\";\n\n// Layouts\n$filterColWidth: 72px;\n$sidebarWidth : 306px;\n$sidebarMaintenanceWidth: $sidebarWidth + 131px;\n$sidebarWidthResponsive : $sidebarWidth;\n$logoSectionHeight: 44px;\n$headerNavWidth: 150px;\n$headerHeight: 48px;\n$footerHeight: 24px;\n$mapFiltersHeight: 36px;\n$mapWidgetsHeight: 150px;\n$topGap: $headerHeight + 1;\n\n$themeColorInverse: #fff;\n$textColor: #333;\n$body-color: #333;\n$logoColor: $themeColor; //#012D55;\n\n\n\n// Header \n\n$borderColor: transparent;\n$linkColor: #fff;\n$hoverBg: #fff;\n$hoverColor: $themeColor;\n$hoverBorderColor: transparent;\n$subMenuHoverBg: $hoverBg;\n$subMenuHoverColor: $hoverColor;\n$menuBg: #045266;\n$blue : #012D55;\n\n\n// general\n$darkGrey: #666;\n$badgeColor: #fff;\n$badgeBgColor: $darkGrey;\n$greenColor: #28a745;\n$redColor: #dc3545;\n$skyColor: $themeColor;\n$yellowColor: #ffc107;\n$bodyBg: #ffffff;\n$lightGrey: #b7b7b7;\n\n$dropdown-bg: #fff;\n$dropdown-border: darken($dropdown-bg, 30%);\n\n\n\n$danger : $redColor;\n$warning : $yellowColor;\n$success : $greenColor;\n\n\n// Sidebar \n$sidebarBackground: #fff;\n$sidebarzIndex: 99999;\n$sidebarHeadBg: #ffffff;\n$sidebarRowBg: #fff;\n$sidebarRowHoverBg: #f7f7f7;\n$sidebarRowColor: $darkGrey;\n\n\n// typography\n$baseFontSize: 12px;\n$baseIconFontSize: 17px;\n\n\n// Footer\n\n$footerBackground: #ececec;\n$footerFontSize: $baseFontSize + 2;\n\n\n\n\n\n$baseFontFamily: Inter, sans-serif;\n$altFontFamily: 'Bebas Neue', sans-serif;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
